export const environment = {
    production: true,
    // Live DEX backend. Point REACT_APP_API_BASE_URL at the USDX-hosted
    // deployment once it exists — the default keeps the API reachable today.
    baseURL:
        process.env.REACT_APP_API_BASE_URL || "https://dex-backend.api.usdx.live/",
};

